// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "/**\n * No After Effects Modal\n */\n.no-after-effects-modal { width:700px; }", "",{"version":3,"sources":["NoAfterEffects.css"],"names":[],"mappings":"AAAA;;EAEE;AACF,0BAA0B,WAAW,EAAE","file":"NoAfterEffects.css","sourcesContent":["/**\n * No After Effects Modal\n */\n.no-after-effects-modal { width:700px; }"]}]);
// Exports
module.exports = exports;
